import Vue from 'vue'

const search = (query) => {
  const params = { q: query }
  return Vue.prototype.$http.get('zones', { params: params })
}

const searchByZip = (zip) => {
  return Vue.prototype.$http.get('zones', { params: { zip } })
}

const fetchAll = (pagination) => {
  const params = pagination
  return Vue.prototype.$http.get('zones', { params })
}

const create = (zoneDef) => {
  return Vue.prototype.$http.post('zones/create', zoneDef)
}

const update = (zoneDef) => {
  return Vue.prototype.$http.put(`zones/update/${zoneDef.zone.id}`, zoneDef)
}

const fetchOne = (id) => {
  return Vue.prototype.$http.get(`zones/${id}`)
}
const fetchStates = () => {
  return Vue.prototype.$http.get('zones/states')
}

export default {
  search,
  searchByZip,
  fetchAll,
  fetchOne,
  create,
  update,
  fetchStates,
}
